// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const Hint: MarkdocTagRegistration = {
  tag: 'hint',
  component: 'Hint',
};
